import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import { fieldsType } from "@/utils/types/field";
import CurrencyFieldDetail from "./detail";
import CurrencyFieldEdit from "./edit";
import CurrencyFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type Currency en: </b>
 * <li>Liste</li>
 * <li>Détails</li>
 * <li>Édition</li>
 */
export function Currency() {
    return _jsx(_Fragment, { children: "Currency" });
}
var field = fieldsType.currency;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, CurrencyFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, CurrencyFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, CurrencyFieldList);
